import { render, staticRenderFns } from "./DocumentsTable.vue?vue&type=template&id=d1ba1cc0&scoped=true&"
import script from "./DocumentsTable.vue?vue&type=script&lang=js&"
export * from "./DocumentsTable.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsTable.vue?vue&type=style&index=0&id=d1ba1cc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ba1cc0",
  null
  
)

export default component.exports